import messages from './messages.json';
import forms from './forms.json';
import collections from './collections.json';
import dateTime from './dateTime.json';
import errors from './errors.json';

export default {
  forms,
  errors,
  collections,
  dateTime,
  ...messages,
};
